import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ModuleLandingCompact } from '../components/layout/module-landing-compact';
import { Package, Users, ShoppingCart, BarChart3, Settings, FileText, Database, Activity, TrendingUp, DollarSign, Box, Truck, UserCheck, CreditCard, PieChart, Mail, Bell, Lock, Globe } from 'lucide-react';
const sampleCategories = [
    {
        id: 'masters',
        title: 'Masters',
        description: 'Core master data',
        icon: _jsx(Database, { className: "w-4 h-4" }),
        color: 'blue',
        items: [
            {
                label: 'Products',
                path: '/inventory/products',
                description: 'Manage product catalog',
                icon: _jsx(Package, { className: "w-3.5 h-3.5" }),
                count: 1247
            },
            {
                label: 'Categories',
                path: '/inventory/categories',
                description: 'Product categories',
                icon: _jsx(Box, { className: "w-3.5 h-3.5" }),
                count: 45
            },
            {
                label: 'Customers',
                path: '/sales/customers',
                description: 'Customer database',
                icon: _jsx(Users, { className: "w-3.5 h-3.5" }),
                count: 892
            },
            {
                label: 'Suppliers',
                path: '/purchase/suppliers',
                description: 'Supplier management',
                icon: _jsx(Truck, { className: "w-3.5 h-3.5" }),
                count: 127,
                badge: 'NEW'
            },
            {
                label: 'Warehouses',
                path: '/inventory/warehouses',
                description: 'Storage locations',
                icon: _jsx(Database, { className: "w-3.5 h-3.5" }),
                count: 8
            },
        ]
    },
    {
        id: 'transactions',
        title: 'Transactions',
        description: 'Daily operations',
        icon: _jsx(Activity, { className: "w-4 h-4" }),
        color: 'green',
        items: [
            {
                label: 'Sales Orders',
                path: '/sales/orders',
                icon: _jsx(ShoppingCart, { className: "w-3.5 h-3.5" }),
                count: 324,
                badge: 'TODAY'
            },
            {
                label: 'Purchase Orders',
                path: '/purchase/orders',
                icon: _jsx(CreditCard, { className: "w-3.5 h-3.5" }),
                count: 89
            },
            {
                label: 'Invoices',
                path: '/sales/invoices',
                icon: _jsx(FileText, { className: "w-3.5 h-3.5" }),
                count: 156
            },
            {
                label: 'Payments',
                path: '/finance/payments',
                icon: _jsx(DollarSign, { className: "w-3.5 h-3.5" }),
                count: 47
            },
            {
                label: 'Stock Entries',
                path: '/inventory/entries',
                icon: _jsx(Box, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Deliveries',
                path: '/sales/deliveries',
                icon: _jsx(Truck, { className: "w-3.5 h-3.5" }),
                badge: 'URGENT'
            },
        ]
    },
    {
        id: 'reports',
        title: 'Reports',
        description: 'Analytics & insights',
        icon: _jsx(BarChart3, { className: "w-4 h-4" }),
        color: 'purple',
        items: [
            {
                label: 'Sales Report',
                path: '/reports/sales',
                icon: _jsx(TrendingUp, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Inventory Report',
                path: '/reports/inventory',
                icon: _jsx(PieChart, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Financial Report',
                path: '/reports/financial',
                icon: _jsx(DollarSign, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Customer Analysis',
                path: '/reports/customers',
                icon: _jsx(UserCheck, { className: "w-3.5 h-3.5" })
            },
        ]
    },
    {
        id: 'settings',
        title: 'Settings',
        description: 'System configuration',
        icon: _jsx(Settings, { className: "w-4 h-4" }),
        color: 'orange',
        collapsed: true, // Start collapsed
        items: [
            {
                label: 'General Settings',
                path: '/settings/general',
                icon: _jsx(Settings, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'User Management',
                path: '/settings/users',
                icon: _jsx(Users, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Permissions',
                path: '/settings/permissions',
                icon: _jsx(Lock, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Email Config',
                path: '/settings/email',
                icon: _jsx(Mail, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Notifications',
                path: '/settings/notifications',
                icon: _jsx(Bell, { className: "w-3.5 h-3.5" })
            },
            {
                label: 'Localization',
                path: '/settings/locale',
                icon: _jsx(Globe, { className: "w-3.5 h-3.5" })
            },
        ]
    }
];
// Extended categories for testing many columns
const extendedCategories = [
    ...sampleCategories,
    {
        id: 'hr',
        title: 'Human Resources',
        icon: _jsx(Users, { className: "w-4 h-4" }),
        color: 'indigo',
        items: [
            { label: 'Employees', path: '/hr/employees', count: 234 },
            { label: 'Attendance', path: '/hr/attendance' },
            { label: 'Payroll', path: '/hr/payroll', badge: 'DUE' },
            { label: 'Leave Management', path: '/hr/leaves' },
        ]
    },
    {
        id: 'crm',
        title: 'CRM',
        icon: _jsx(UserCheck, { className: "w-4 h-4" }),
        color: 'red',
        items: [
            { label: 'Leads', path: '/crm/leads', count: 89 },
            { label: 'Opportunities', path: '/crm/opportunities', count: 23 },
            { label: 'Campaigns', path: '/crm/campaigns' },
            { label: 'Activities', path: '/crm/activities' },
        ]
    }
];
export const ModuleLandingCompactShowcase = () => {
    const [selectedExample, setSelectedExample] = React.useState('basic');
    const [favorites, setFavorites] = React.useState([
        '/inventory/products',
        '/inventory/entry',
        '/reports/sales'
    ]);
    const handleNavigate = (path) => {
        console.log('Navigating to:', path);
    };
    const handleFavoriteToggle = (path, isFavorite) => {
        setFavorites(prev => isFavorite
            ? [...prev, path]
            : prev.filter(fav => fav !== path));
        console.log('Favorite toggled:', path, isFavorite);
    };
    return (_jsxs("div", { className: "space-y-6", children: [_jsxs("div", { children: [_jsx("h2", { className: "text-2xl font-bold text-gray-900 dark:text-white mb-2", children: "Module Landing Compact" }), _jsx("p", { className: "text-gray-600 dark:text-gray-400", children: "A space-efficient, dynamic column layout for module landing pages with multiple view modes." })] }), _jsxs("div", { className: "flex gap-2", children: [_jsx("button", { onClick: () => setSelectedExample('basic'), className: `px-4 py-2 rounded-lg font-medium transition-colors ${selectedExample === 'basic'
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`, children: "Basic (4 Categories)" }), _jsx("button", { onClick: () => setSelectedExample('extended'), className: `px-4 py-2 rounded-lg font-medium transition-colors ${selectedExample === 'extended'
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`, children: "Extended (6+ Categories)" }), _jsx("button", { onClick: () => setSelectedExample('minimal'), className: `px-4 py-2 rounded-lg font-medium transition-colors ${selectedExample === 'minimal'
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`, children: "Minimal (No Header)" })] }), _jsxs("div", { className: "space-y-6", children: [selectedExample === 'basic' && (_jsxs("div", { className: "border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden", children: [_jsx("div", { className: "bg-gray-50 dark:bg-gray-900 p-3 border-b border-gray-200 dark:border-gray-700", children: _jsx("h3", { className: "text-sm font-semibold text-gray-700 dark:text-gray-300", children: "Full Featured Example (Search + View Toggle + Favorites)" }) }), _jsx("div", { className: "h-[600px]", children: _jsx(ModuleLandingCompact, { title: "Inventory Management", description: "Manage your products, stock, and warehouses", categories: sampleCategories, onNavigate: handleNavigate, showSearch: true, showViewToggle: true, showExpandCollapseAll: true, showFavorites: true, initialFavorites: favorites, onFavoriteToggle: handleFavoriteToggle, defaultView: "compact" }) })] })), selectedExample === 'extended' && (_jsxs("div", { className: "border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden", children: [_jsx("div", { className: "bg-gray-50 dark:bg-gray-900 p-3 border-b border-gray-200 dark:border-gray-700", children: _jsx("h3", { className: "text-sm font-semibold text-gray-700 dark:text-gray-300", children: "Extended Example (6+ Categories, Dynamic Columns)" }) }), _jsx("div", { className: "h-[600px]", children: _jsx(ModuleLandingCompact, { title: "Enterprise Resource Planning", description: "Complete business management system", categories: extendedCategories, onNavigate: handleNavigate, showSearch: true, showViewToggle: true, showExpandCollapseAll: true, showFavorites: true, initialFavorites: favorites, onFavoriteToggle: handleFavoriteToggle, defaultView: "compact", maxColumns: 4 }) })] })), selectedExample === 'minimal' && (_jsxs("div", { className: "border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden", children: [_jsx("div", { className: "bg-gray-50 dark:bg-gray-900 p-3 border-b border-gray-200 dark:border-gray-700", children: _jsx("h3", { className: "text-sm font-semibold text-gray-700 dark:text-gray-300", children: "Minimal Example (No Header, Clean Layout)" }) }), _jsx("div", { className: "h-[500px]", children: _jsx(ModuleLandingCompact, { categories: sampleCategories.slice(0, 3), onNavigate: handleNavigate, showSearch: false, showViewToggle: false, showExpandCollapseAll: true, showFavorites: true, initialFavorites: favorites, onFavoriteToggle: handleFavoriteToggle, defaultView: "compact" }) })] }))] }), _jsxs("div", { className: "bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4", children: [_jsx("h3", { className: "text-sm font-semibold text-blue-900 dark:text-blue-100 mb-2", children: "Key Features" }), _jsxs("ul", { className: "text-sm text-blue-800 dark:text-blue-200 space-y-1", children: [_jsx("li", { children: "\u2713 65% space reduction compared to card layout" }), _jsx("li", { children: "\u2713 Dynamic column layout (adapts to content)" }), _jsx("li", { children: "\u2713 Three view modes: Compact, List, and Grid" }), _jsx("li", { children: "\u2713 Collapsible categories with smooth animations" }), _jsx("li", { children: "\u2713 Expand/Collapse All functionality" }), _jsx("li", { children: "\u2713 Favorites system with themed styling" }), _jsx("li", { children: "\u2713 Dedicated favorites panel with quick access" }), _jsx("li", { children: "\u2713 Built-in search functionality" }), _jsx("li", { children: "\u2713 Support for badges, counts, and icons" }), _jsx("li", { children: "\u2713 Responsive design for all screen sizes" }), _jsx("li", { children: "\u2713 Dark mode support" })] })] }), _jsx("div", { className: "bg-gray-900 text-gray-100 rounded-lg p-4 overflow-x-auto", children: _jsx("pre", { className: "text-sm", children: _jsx("code", { children: `import { ModuleLandingCompact } from '@textile-erp/ui';

const categories = [
  {
    id: 'masters',
    title: 'Masters',
    icon: <Database className="w-4 h-4" />,
    color: 'blue',
    items: [
      { 
        label: 'Products', 
        path: '/products',
        count: 1247,
        badge: 'NEW'
      }
    ]
  }
];

<ModuleLandingCompact
  title="Module Name"
  description="Module description"
  categories={categories}
  onNavigate={(path) => navigate(path)}
  showSearch={true}
  showViewToggle={true}
  showExpandCollapseAll={true}
  showFavorites={true}
  initialFavorites={['/path1', '/path2']}
  onFavoriteToggle={(path, isFavorite) => console.log(path, isFavorite)}
  defaultView="compact"
/>` }) }) })] }));
};
